import { type DetailedHTMLProps, type HTMLAttributes } from "react"

import { cn } from "#app/utils/misc"

const SRCSET_WIDTHS = [200, 400, 600, 700, 800, 1200]

function buildSrcSet(src: string, format: "webp" | "jpeg") {
	return SRCSET_WIDTHS.map(w => `${src}?w=${w}&format=${format} ${w}w`).join(
		", ",
	)
}

export default function LoaderImage({
	src,
	alt,
	sizes = "(max-width: 640px) 95vw, (max-width: 1024px) 50vw, 33vw",
	loading = "lazy",
	decoding = "async",
	fetchPriority,
	className,
	...props
}: {
	alt: string
	src: string
	sizes?: string
	loading?: "lazy" | "eager"
	decoding?: "async" | "sync"
	fetchPriority?: "high" | "low" | "auto"
} & DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
	return (
		<div
			className={cn(
				"relative aspect-square w-full overflow-hidden rounded-lg bg-gray-200",
				className,
			)}
		>
			<picture>
				<source
					type="image/webp"
					srcSet={buildSrcSet(src, "webp")}
					sizes={sizes}
				/>
				<img
					alt={alt}
					src={`${src}?w=1200&format=jpeg`}
					srcSet={buildSrcSet(src, "jpeg")}
					className="h-full w-full object-cover object-center group-hover:opacity-75"
					sizes={sizes}
					loading={loading}
					decoding={decoding}
					// @ts-ignore This is a peculiar error. When I spell it correctly, an error appears in the console. However, when I spell it in lowercase, as the error suggests, it results in an error in the IDE.
					fetchpriority={fetchPriority}
					{...props}
				/>
			</picture>
		</div>
	)
}
